// extracted by mini-css-extract-plugin
module.exports = {"card-layout":"eventCard_card-layout__S4Vbr","image":"eventCard_image__DoRTf"};